import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { CUICard } from '../CUICard/CUICard';

/**
- A CUIHomepageCard should contain a `CUIHomepageCardDescriptionSection` and a `CUIHomepageCardImageSection`.
- CUIHomepageCard will hide the media on smaller viewports, hence the need for the `mediaSide` prop
**/
const CUIHomepageCard = (_ref) => {
  let {
    mediaSide,
    media,
    description
  } = _ref,
      rest = _objectWithoutPropertiesLoose(_ref, ["mediaSide", "media", "description"]);

  return /*#__PURE__*/_jsxs(CUICard, Object.assign({
    direction: {
      base: 'column',
      md: `row${mediaSide === 'left' ? '' : '-reverse'}`
    },
    overflow: "hidden",
    maxWidth: "1000px",
    size: "lg",
    padding: 0
  }, rest, {
    children: [media, description]
  }));
};

export default CUIHomepageCard;